import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrokerWidgetContext } from '../../../../../../../shared/containers/NewbuildingBrokerWidgetProvider';
import { useNewbuildingBrokerAnalyticsUser } from '../../../../../../../shared/hooks/useNewbuildingBrokerAnalyticsUser';
import { getCurrentRegionId } from '../../../../../../../shared/selectors/getCurrentRegionId';
import { getJsonQuery } from '../../../../../../../shared/selectors/getJsonQuery';
import { getIsNeedSelfEmployedConfirmation } from '../../../../../../../shared/selectors/newbuildingBroker';
import { getNewbuildingBrokerSettings } from '../../../../../../../shared/selectors/newbuildingBroker/getNewbuildingBrokerSettings';
import { trackSellApartmentClick } from '../../../../../../../shared/tracking/newbuilding/broker';
import { TNewbuildingBrokerFlow } from '../../../../../../../shared/types/newbuildingBroker';
import { NewbuildingBrokerButton } from '../../../../components/NewbuildingBrokerButton';
import { useOfferContext } from '../../../../context';

export const NewbuildingBrokerButtonContainer: React.VFC = () => {
  const {
    offer: { newbuilding, newbuildingBroker },
  } = useOfferContext();

  const newbuildingBrokerSettings = useSelector(getNewbuildingBrokerSettings);
  const flowType = newbuildingBroker?.availableBrokerFlow as TNewbuildingBrokerFlow;
  const newbuildingRegionId = useSelector(getCurrentRegionId);
  const isSelfEmployed = useSelector(getIsNeedSelfEmployedConfirmation);
  const jsonQuery = useSelector(getJsonQuery);

  const openWidget = React.useContext(NewbuildingBrokerWidgetContext);

  const user = useNewbuildingBrokerAnalyticsUser(flowType);

  const [loading, setLoading] = React.useState(false);

  const handleButtonClick = React.useCallback(async () => {
    trackSellApartmentClick(jsonQuery, user);

    const newbuildingId = Number(newbuilding?.id) || null;
    const houseId = Number(newbuilding?.house?.id) || null;

    setLoading(true);

    await openWidget({
      flowType,
      newbuildingId,
      newbuildingRegionId,
      houseId,
      isSelfEmployed,
      trackingParams: {
        pageType: 'Listing',
        siteType: 'desktop',
        user,
      },
    });

    setLoading(false);
  }, [flowType, jsonQuery, isSelfEmployed, newbuilding, newbuildingRegionId, openWidget, user]);

  const handleContainerClick: React.MouseEventHandler = React.useCallback(event => event.stopPropagation(), []);

  const isEnabledInConfig = newbuildingBrokerSettings?.enabled;

  if (!isEnabledInConfig || !newbuildingBroker?.availableBrokerFlow) {
    return null;
  }

  return (
    <div onClick={handleContainerClick}>
      <NewbuildingBrokerButton loading={loading} onClick={handleButtonClick} />
    </div>
  );
};
